import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { User} from "../../../generated/graphql";
import { FieldInputProps, FieldMetaState } from "react-final-form";
import { FieldValueGetter } from "@apollo/client/cache/inmemory/entityStore";
import {useStyles} from "../Style/Style";

interface DictionaryUserSelectProps {
  label: string;
  values?:User[];
  input: FieldInputProps<User>;
  meta: FieldMetaState<FieldValueGetter>;
}

export function DictionaryUserSelect({
  label,
  values,
  input,
  meta,
}: DictionaryUserSelectProps) {
  const classes = useStyles();

  return (
    <FormControl className={classes.root} variant="filled" error={meta.error && meta.touched} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={input.value.id}
        onChange={(e) => {
          input.onChange({
            id: e.target.value,
          });
        }}
        fullWidth
      >
        {values?.map((value: User) => {
          return (
            <MenuItem key={value?.id} value={value?.id as string}>
              {`${value?.firstName} ${value?.lastName}`}
            </MenuItem>
          );
        })}
      </Select>
      {meta.error && meta.touched && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
}
